// Item-name aliases: old name → current name. FFTBG renamed a lot of items over its
// 6-year history, so old units (champ-history loadouts, the Units tab) carry names that
// no longer match the current item list. The map is FFTBG's own rename list
// (fftbattleground.com/fftbg/legacyitem.txt), snapshotted by tools/fetchGameData.mjs into
// data/legacyItems.js. Used by The Collector quest (an old-name champ credits the current
// item) and the unit search (a filter on the current name also finds the old one).
//
// It replaced a hand-made list of 23 (2026-10-18). The official list differs in a few
// places: Hidden Knife is Blind Knife (not Kunai), and Broad Sword / Long Sword (now Iron
// Sword) and Ice Bow (now Silver Bow) weren't removed but renamed.
import { LEGACY_ITEM_NAMES } from '../data/legacyItems.js';

export const ITEM_ALIASES = LEGACY_ITEM_NAMES;

export const canonItem = (name) => (name && ITEM_ALIASES[name]) || name;
